import { Controller } from "@hotwired/stimulus";
import { gsap } from 'gsap';
import getRect from "../../utilities/getRect";
import prefersReducedMotion from "../../utilities/prefersReducedMotion";
import enableAnimationBreakpoint from "../../utilities/enableAnimationBreakpoint";
export default class extends Controller {
  static targets = ['header', 'cursor'];

  connect() {

    const reduceMotion = prefersReducedMotion();
    const enableAnimation = enableAnimationBreakpoint();

    if(!reduceMotion && enableAnimation) {
      this.initAnimatedCursor();
    }
  }

  initAnimatedCursor() {
    this.pos = { x: 0, y: 0 };
    this.mouse = { x: this.pos.x, y: this.pos.y };
    this.speed = 0.1;

    this.header = document.querySelector('.header');

    gsap.set(this.cursorTarget, {scale: 0 });

    this.xSet = gsap.quickSetter(this.cursorTarget, "x", "px");
    this.ySet = gsap.quickSetter(this.cursorTarget, "y", "px");

    this.header.addEventListener('mouseenter', (e) => {
      gsap.to(this.cursorTarget, {scale: 1, opacity: 1, duration: 0.3 });
    
      window.addEventListener("mousemove", this.updateMouseValues.bind(this));
    });
    
    this.header.addEventListener('mouseleave', (e) => {
      gsap.to(this.cursorTarget, {scale: 0, duration: 0.3 });
      window.removeEventListener("mousemove", this.updateMouseValues.bind(this));
    });
    
    gsap.ticker.add(this.update.bind(this));
  }

  updateMouseValues(e) {
    this.mouse.x = e.x;
    this.mouse.y = e.y;  
  }

  update() {
    const dt = 1.0 - Math.pow(1.0 - this.speed, gsap.ticker.deltaRatio()); 

    this.pos.x += (this.mouse.x - this.pos.x) * dt;
    this.pos.y += (this.mouse.y - this.pos.y) * dt;

    this.xSet(this.pos.x);
    this.ySet(this.pos.y);
  }
}